/**
 * Costume Type
 */
export enum CostumeType {
  Standard = "Standard",
  EveningWear = "Evening Wear",
  PeriodWear = "Period Wear",
}
